import { render } from "./Debit.vue?vue&type=template&id=75566c8a&scoped=true&ts=true"
import script from "./Debit.vue?vue&type=script&lang=ts"
export * from "./Debit.vue?vue&type=script&lang=ts"

import "./Debit.vue?vue&type=style&index=0&id=75566c8a&scoped=true&lang=css"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75566c8a"]])

export default __exports__